/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Product_Sub_Family_Name_Enum =
  | 'BAKERY'
  | 'BEER_CIDER'
  | 'CLOTHING_TEXTILE'
  | 'DAIRY'
  | 'DELI'
  | 'FISH_SEAFOOD'
  | 'FLORAL'
  | 'FROZEN_FOOD'
  | 'FRUITS'
  /**   */
  | 'GAMES_TOYS'
  | 'HOUSEHOLD_CLEANING'
  | 'HYGIENE_BEAUTY'
  | 'NON_ALCOHOLIC_BEVERAGES'
  | 'PETS'
  | 'RAW_MEAT'
  | 'SALTY_GROCERY'
  | 'SPIRITS'
  | 'SWEET_GROCERY'
  | 'VEGETABLES'
  | 'VEGETARIAN_VEGAN'
  | 'WINE_CHAMPAGNE_SPARKLING';

export type ProductSubFamiliesByFamilyQueryVariables = Exact<{
  productFamily?: string | null | undefined;
}>;


export type ProductSubFamiliesByFamilyQuery = { product_sub_family: Array<{ name: Types.Product_Sub_Family_Name_Enum }> };


export const ProductSubFamiliesByFamilyDocument = /*#__PURE__*/ gql`
    query ProductSubFamiliesByFamily($productFamily: String) {
  product_sub_family(where: {product_family_name: {_eq: $productFamily}}) {
    name
  }
}
    `;

/**
 * __useProductSubFamiliesByFamilyQuery__
 *
 * To run a query within a React component, call `useProductSubFamiliesByFamilyQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductSubFamiliesByFamilyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductSubFamiliesByFamilyQuery({
 *   variables: {
 *      productFamily: // value for 'productFamily'
 *   },
 * });
 */
export function useProductSubFamiliesByFamilyQuery(baseOptions?: Apollo.QueryHookOptions<ProductSubFamiliesByFamilyQuery, ProductSubFamiliesByFamilyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductSubFamiliesByFamilyQuery, ProductSubFamiliesByFamilyQueryVariables>(ProductSubFamiliesByFamilyDocument, options);
      }
export function useProductSubFamiliesByFamilyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductSubFamiliesByFamilyQuery, ProductSubFamiliesByFamilyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductSubFamiliesByFamilyQuery, ProductSubFamiliesByFamilyQueryVariables>(ProductSubFamiliesByFamilyDocument, options);
        }
// @ts-ignore
export function useProductSubFamiliesByFamilySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductSubFamiliesByFamilyQuery, ProductSubFamiliesByFamilyQueryVariables>): Apollo.UseSuspenseQueryResult<ProductSubFamiliesByFamilyQuery, ProductSubFamiliesByFamilyQueryVariables>;
export function useProductSubFamiliesByFamilySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductSubFamiliesByFamilyQuery, ProductSubFamiliesByFamilyQueryVariables>): Apollo.UseSuspenseQueryResult<ProductSubFamiliesByFamilyQuery | undefined, ProductSubFamiliesByFamilyQueryVariables>;
export function useProductSubFamiliesByFamilySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductSubFamiliesByFamilyQuery, ProductSubFamiliesByFamilyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductSubFamiliesByFamilyQuery, ProductSubFamiliesByFamilyQueryVariables>(ProductSubFamiliesByFamilyDocument, options);
        }
export type ProductSubFamiliesByFamilyQueryHookResult = ReturnType<typeof useProductSubFamiliesByFamilyQuery>;
export type ProductSubFamiliesByFamilyLazyQueryHookResult = ReturnType<typeof useProductSubFamiliesByFamilyLazyQuery>;
export type ProductSubFamiliesByFamilySuspenseQueryHookResult = ReturnType<typeof useProductSubFamiliesByFamilySuspenseQuery>;
export type ProductSubFamiliesByFamilyQueryResult = Apollo.QueryResult<ProductSubFamiliesByFamilyQuery, ProductSubFamiliesByFamilyQueryVariables>;